/*
 * BBC - Rap Map - Close Video & Marker pop-ups
 *
 * @author Matt Haynes <matt@joipolloi.com>
 * @package BBC Rap Map
 */

import React from 'react';

import CloseIcon from './assets/CloseIcon.svg';

const CloseButton = ({ onClick, ariaText }) => (
    <button className="CloseButton" onClick={onClick}>
        <img src={CloseIcon} alt="" /> <span className="vh">{ariaText ? ariaText : ''}</span>
    </button>
);

export default CloseButton;
